import { error, finish } from '../../../modules/banners/actions/update-banner-slide-time';
import api from '../../../api';

export function request(dispatch, { sec }) {
    api.post('/banners/configures', {
        id: 'banner-config',
        configs: {
            'banner-slide-time': sec
        }
    }).then(res => {
        dispatch(finish(res));
    }).catch(err => {
        dispatch(error(err));
    });
}
